
import { ElDatePicker } from "element-plus";
import { PropType, defineComponent } from "vue";
export default defineComponent({
  name: "customDatePicker",
  props: {
    modelValue: {
      type: Object as PropType<Date[]>,
    },
    inputId: {
      type: String as PropType<string>,
      required: true,
    },
    labelName: { type: String as PropType<string>, required: true },
  },
  data() {
    return {
      shortcuts: [
        {
          text: "最近一週間",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          })(),
        },
        {
          text: "最近一ヶ月",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          })(),
        },
        {
          text: "最近三ヶ月",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          })(),
        },
      ],
    };
  },
  computed: {
    isEmpty(): boolean {
      return !this.modelValue;
    },
    defaultDate(): Date {
      const time = new Date();
      time.setTime(new Date().getTime() - 3600 * 1000 * 24 * 30);
      return time;
    },
  },
  emits: ["update:modelValue", "enterKeyUp"],
  methods: {
    modelValueChange(value: string): void {
      this.$emit("update:modelValue", value);
    },
    selectDate() {
      (this.$refs.dataPicker as typeof ElDatePicker).focus();
    },
  },
});
